export const MESSAGE_TYPE_IMAGE = 'image'
export const MESSAGE_TYPE_FILE = 'application'
export const LINK_BANNER = 'https://www.vitalnet.jp/company/baseball/bcsupport'
export const veevalidate_attributes = {
  form_email: 'メールアドレス',
  password: 'パスワード',
  password_confirmation: '（確認用）パスワード'
}

export const allowedFileTypes = {
  office: ['.doc', '.docx', '.xls', '.xlsx', '.ppt', '.pptx', '.csv'],
  image: ['.png', '.jpg', '.jpeg'],
  document: ['.pdf'],
  movie: ['.mp4', '.mov'],
  other: ['.zip', '.ai']
}



// WEBPACK FOOTER //
// ./src/config/const.js